import { render } from "./OuterPasswordEdit.vue?vue&type=template&id=3847c85c&scoped=true&ts=true"
import script from "./OuterPasswordEdit.vue?vue&type=script&lang=ts"
export * from "./OuterPasswordEdit.vue?vue&type=script&lang=ts"

import "./OuterPasswordEdit.vue?vue&type=style&index=0&id=3847c85c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3847c85c"]])

export default __exports__